module.exports = __webpack_public_path__ + "static/img/tx.d64bc39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tx.png
// module id = +RyT
// module chunks = 57